<template>
  <div class="myPagination">
    <i-page
      show-elevator
      show-sizer
      show-total
      placement="top"
      @on-page-size-change="handleSize"
      @on-change="handleCurrent"
      :current="pageNum"
      :page-size-opts="pageSizeOptions"
      :page-size="pageSize"
      :total="msgCount"
    ></i-page>
  </div>
</template>
<script>
import { Page } from "view-design";
export default {
  name: "myPagination",
  props: {
    // 当前页
    pageNum: { default: 1 },
    // 页大小
    pageSize: { default: 15 },
    // 总记录数
    msgCount: { default: 0 },
    query: { default: "" },
    startTime: {},
    endTime: {},
    category: {},
    pageSizeOptions: {
      type: Array,
      default: () => [15, 30, 50, 100]
    }
  },
  components: {
    "i-page": Page
  },
  computed: {
    userStatus() {
      return this.$store.getters.getStatus;
    }
  },
  methods: {
    // 监听页大小变化
    handleSize(val) {
      console.log('1',val)
      // 触发父组件监听的事件，请求新数据
      this.$emit("paginate", {
        pageSize: val
      });
    },
    // 监听当前页变化
    handleCurrent(val) {
      console.log('2',val)
      // 触发父组件监听的事件，请求新数据
      this.$emit("paginate", {
        pageNum: val
      });
    }
  },
  watch: {
    msgCount(val) {
      let pageNum = this.pageNum;
      while (val < (pageNum - 1) * this.pageSize) {
        pageNum--;
      }
      console.log('3',val)
      if (val < (this.pageNum - 1) * this.pageSize) {
        console.log('4')
        // 触发父组件监听的事件，请求新数据
        this.$emit("paginate", {
          pageNum
        });
      }
    }
  },
  beforeDestroy() {
    if (this.$route.meta.alias === this.$route.path) {
      return;
    }
    console.log("保存当前分页信息");
    this.$store.commit("skb/updateLimitQuery", {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      query: this.query,
      startTime: this.startTime,
      endTime: this.endTime,
      category: this.category
    });
  }
};
</script>
<style lang="scss" scoped>
.myPagination {
  margin-top: $top;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: $top;
  width: 60vw;
  min-width: 850px;
  /deep/ .ivu-select {
    width: auto !important;
  }
}
</style>
